import PropTypes from 'prop-types';

import { styled } from '@prose-ui/legacy';

const OffCenterWrapper = styled('div')(({ value }) => ({
  marginTop: value,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  textAlign: 'center',
  alignItems: 'center',
}));

OffCenterWrapper.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]).isRequired,
};

export default OffCenterWrapper;
